
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConstantsService } from 'src/app/services/constants.service';
import { PlanInstitucional } from '../models/plan-institucional';

@Injectable({
  providedIn: 'root'
})
export class PlanInstitucionalService {
  private url = ConstantsService.PLANES_INSTITUCIONALES_URL;
  constructor(private http:HttpClient) { }

  create(formData:any): Observable<any> {
      return this.http.post(`${this.url}`, formData).pipe(map(
      data => {return data;}
    ));
  }
  list(query =''): Observable<any> {
    return this.http.get(`${this.url}${query}`).pipe(map(
     data => {return data;}
   ));
 }

 getPlanInstitucionalId(id: number): Observable<PlanInstitucional> {
  return this.http.get<PlanInstitucional>(`${this.url}${id}`);    
}

  update(formData:any): Observable<any> {
       let {idSprPlanInstitucional} = formData;
    return this.http.patch(`${this.url}${idSprPlanInstitucional}`,formData).pipe(map(
      data => {
        return data;
      }
    ));
  }
  delete(dataDelete:any): Observable<any> {
    return this.http.patch(`${this.url}${dataDelete.idSprPlanInstitucional}`,dataDelete ) }
}


